import { render, staticRenderFns } from "./illegallyInfo.vue?vue&type=template&id=0e548ab6&scoped=true&"
import script from "./illegallyInfo.vue?vue&type=script&lang=js&"
export * from "./illegallyInfo.vue?vue&type=script&lang=js&"
import style0 from "./illegallyInfo.vue?vue&type=style&index=0&id=0e548ab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e548ab6",
  null
  
)

export default component.exports